import { Box } from '@mui/material';
import { LayoutSwitcherProps } from '../DealsFilters.types';

import { LayoutType } from 'model/deals.model';
import zeplinColor from 'theme/Color';
import styles from '../DealsFilters.module.css';

export const LayoutSwitcher = ({ layout, onLayoutChange }: LayoutSwitcherProps) => {
  return (
    <Box
      sx={{
        borderRadius: '50px',
        border: `1px solid ${zeplinColor.Neutral6}`,
        padding: '6px',
        width: { xs: '82px', xl: '92px' },
        height: { xs: '40px', xl: '48px' },
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: zeplinColor.Neutral1,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: { xs: '35px', xl: '40px' },
          height: { xs: '28px', xl: '36px' },
          backgroundColor: zeplinColor.Brand1,
          opacity: 0.1,
          borderRadius: '40px',
          transition: 'transform 0.3s ease',
          transform:
            layout === LayoutType.KANBAN
              ? 'translateX(0)'
              : { xs: 'translateX(35px)', xl: 'translateX(40px)' },
          left: '6px',
        }}
      />

      <Box
        onClick={(e) => onLayoutChange(e, LayoutType.KANBAN)}
        sx={{
          zIndex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '40px',
          height: '100%',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
      >
        <img
          src={
            layout === LayoutType.KANBAN
              ? `/assets/selected-col-layout.svg`
              : `/assets/column-layout-icon.svg`
          }
          className={layout === LayoutType.KANBAN ? styles['icons'] : styles['selected-icons']}
          alt='Column layout'
          style={{
            transition: 'all 0.2s ease',
            transform: layout === LayoutType.KANBAN ? 'scale(1.1)' : 'scale(1)',
          }}
        />
      </Box>

      <Box
        onClick={(e) => onLayoutChange(e, LayoutType.LIST)}
        sx={{
          zIndex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '40px',
          height: '100%',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
      >
        <img
          src={
            layout === LayoutType.LIST
              ? `/assets/selected-row-layout.svg`
              : `/assets/row-layout-icon.svg`
          }
          className={layout === LayoutType.LIST ? styles['icons'] : styles['selected-icons']}
          alt='Row layout'
          style={{
            transition: 'all 0.2s ease',
            transform: layout === LayoutType.LIST ? 'scale(1.1)' : 'scale(1)',
          }}
        />
      </Box>
    </Box>
  );
};
